import { MenuItem, styled, Typography } from '@mui/material';
import { useSession } from 'App';

const DisappearingButton = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down(924)]: {
    display: 'none',
  },
  [theme.breakpoints.up(924)]: {
    display: 'flex',
    marginLeft: 24,
  },
  cursor: 'pointer',
  '&:hover': {
    color: theme.palette.black.main,
  },
}));

type PropsType = { isMenu?: boolean };

export const LogoutButton = ({ isMenu }: PropsType) => {
  const { logout } = useSession();
  const title = 'Logout';
  return isMenu ? (
    <MenuItem key={title} sx={{ minHeight: 40 }} onClick={logout}>
      <Typography variant='navLink'>{title}</Typography>
    </MenuItem>
  ) : (
    <DisappearingButton onClick={logout} variant='navLink'>
      {title}
    </DisappearingButton>
  );
};
